$(function() {

  $('.search-cta').on('click', function(){
    $('.header').addClass('header--search');
    $('.cart-box').removeClass('active');
    setTimeout(function() {
      $('.search__input').focus();
    }, 200);
  });

  $('.search__close').on('click', function(e){
    e.preventDefault();
    $('.header').removeClass('header--search');
    $('.search-results').removeClass('active');
  });

  $('.search__input').on('keyup', function(){
    if ($(this).val().length > 2) {
      $('.search__autocomplete').addClass('search__autocomplete--open');
    } else {
      $('.search__autocomplete').removeClass('search__autocomplete--open');
    }
  });

});
